module.exports = __webpack_public_path__ + "static/media/tiktok.b31b6acd.png";